import styled from '@emotion/styled'

export const FormStyleRoot = styled.div(({theme}) => ({
	display: 'contents',
	...theme.baseStyles.formRoot,
}))
